import { useEffect } from 'react';

/**
 * 修飾キーの状態を追跡してHTMLにクラスを付けるカスタムフック
 */
export const useModifierKeyClasses = () => {
  useEffect(() => {
    // プラットフォーム判定
    const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    
    // 修飾キーの状態を追跡
    const modifierStates = {
      shift: false,
      ctrlOption: false,
      altControl: false,
      winCmd: false
    };

    const updateModifierClasses = () => {
      const htmlElement = document.documentElement;
      
      // 既存の修飾キークラスを削除
      htmlElement.classList.remove(
        'shift-key',
        'ctrloption-key', 
        'altcontrol-key',
        'wincmd-key'
      );
      
      // 現在の状態に応じてクラスを追加
      if (modifierStates.shift) {
        htmlElement.classList.add('shift-key');
      }
      if (modifierStates.ctrlOption) {
        htmlElement.classList.add('ctrloption-key');
      }
      if (modifierStates.altControl) {
        htmlElement.classList.add('altcontrol-key');
      }
      if (modifierStates.winCmd) {
        htmlElement.classList.add('wincmd-key');
      }
    };

    const handleKeyDown = (e: KeyboardEvent) => {
      let stateChanged = false;

      if (e.key === 'Shift') {
        modifierStates.shift = true;
        stateChanged = true;
      } else if (e.key === 'Control') {
        if (isMac) {
          modifierStates.altControl = true;
        } else {
          modifierStates.ctrlOption = true;
        }
        stateChanged = true;
      } else if (e.key === 'Alt') {
        if (isMac) {
          modifierStates.ctrlOption = true;
        } else {
          modifierStates.altControl = true;
        }
        stateChanged = true;
      } else if (e.key === 'Meta') {
        modifierStates.winCmd = true;
        stateChanged = true;
      }

      if (stateChanged) {
        updateModifierClasses();
      }
    };

    const handleKeyUp = (e: KeyboardEvent) => {
      let stateChanged = false;

      if (e.key === 'Shift') {
        modifierStates.shift = false;
        stateChanged = true;
      } else if (e.key === 'Control') {
        if (isMac) {
          modifierStates.altControl = false;
        } else {
          modifierStates.ctrlOption = false;
        }
        stateChanged = true;
      } else if (e.key === 'Alt') {
        if (isMac) {
          modifierStates.ctrlOption = false;
        } else {
          modifierStates.altControl = false;
        }
        stateChanged = true;
      } else if (e.key === 'Meta') {
        modifierStates.winCmd = false;
        stateChanged = true;
      }

      if (stateChanged) {
        updateModifierClasses();
      }
    };

    // ウィンドウフォーカスが外れた時に修飾キー状態をリセット
    const handleBlur = () => {
      const wasAnyKeyPressed = Object.values(modifierStates).some(state => state);
      if (wasAnyKeyPressed) {
        modifierStates.shift = false;
        modifierStates.ctrlOption = false;
        modifierStates.altControl = false;
        modifierStates.winCmd = false;
        updateModifierClasses();
      }
    };

    // イベントリスナーを追加
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('keyup', handleKeyUp);
    window.addEventListener('blur', handleBlur);

    // クリーンアップ
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
      window.removeEventListener('blur', handleBlur);
      
      // クリーンアップ時にクラスを削除
      const htmlElement = document.documentElement;
      htmlElement.classList.remove(
        'shift-key',
        'ctrloption-key', 
        'altcontrol-key',
        'wincmd-key'
      );
    };
  }, []);
};
